/**
 * Enable SDUI for web category pages
 */ export var ENABLE_SDUI_WEB_CATEGORY_PAGE_240724 = 'ENABLE_SDUI_WEB_CATEGORY_PAGE_240724';
